import {
    CUSTOMER_REVIEWS_START,
    CUSTOMER_REVIEWS_SUCCESS,
    CUSTOMER_REVIEWS_ERROR,
} from "Constant/RentalCustomer";
    
  const initialState = {
      loading: false,
      data: [],
  };
    
  export default function customerReviewsReducer(
      state = { ...initialState },
      action
  ) {
      switch (action.type) {
        case CUSTOMER_REVIEWS_START:
          return {
            ...state,
            loading: true,
          };
        case CUSTOMER_REVIEWS_SUCCESS:
          return {
            ...state,
            data: action.payload,
            loading: false,
          };
        case CUSTOMER_REVIEWS_ERROR:
          return {
            ...state,
            loading: false,
            message: action.error.message,
          };
        default:
          return state;
      }
  }
    